import React, { ReactElement } from 'react';
import styled from 'styled-components';

interface Props {
  header: string;
  onChange: (value: number) => void;
  value: number;
  min?: number;
  max?: number;
  disabled?: boolean;
}

const Slider = ({
  header,
  onChange,
  value,
  min,
  max,
  disabled,
}: Props): ReactElement => (
  <PanelSlider>
    <SliderContainer>
      <P>{header}:</P>
      <input
        disabled={disabled || false}
        style={{ width: '50px' }}
        type="number"
        min={min || 0}
        max={max || 20}
        value={value}
        onChange={(e): void => onChange(parseInt(e.target.value))}
      />
    </SliderContainer>
    <SliderInput
      disabled={disabled || false}
      type="range"
      min={min || 0}
      max={max || 20}
      value={value}
      onChange={(e): void => onChange(parseInt(e.target.value))}
    />
  </PanelSlider>
);

export default Slider;

const PanelSlider = styled.div`
  background-color: lavender;
  border: 1px solid black;
  border-radius: 0.2rem;
  padding: 0.7em;
  margin: 0 5px;
`;

const SliderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SliderInput = styled.input`
  -webkit-appearance: none;
  height: 0.1em;
  margin-top: 1.5em;
  width: 100%;
  background: black;
`;

const P = styled.p`
  margin: 0 0.5em;
`;
